export default __webpack_public_path__ + "static/media/sohan.29177c9d.jpg";